import { ApiService, ConfigService, StoreHelper, UserService } from '../../../shared/services';
import { Notification, PushNotification, NotificationsFilter, PushNotificationsFilter  } from '../models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment';

@Injectable()
export class NotificationService {
    baseUrl: string = this._configService.getContext('bi').url;
    systemNotificationsPath: string = 'feeds/notifications';
    pushNotificationsPath: string = 'feeds/push';

    systemNotifications: Notification[] = [];
    pushNotifications: PushNotification[] = [];

    constructor(private _storeHelper: StoreHelper,
                private _configService: ConfigService,
                private _userService: UserService,
                private _apiService: ApiService,
                ) { }

    getSystemNotifications(regions: number[] = [],
                           page = 1,
                           size = 50,
                           start?: string): Observable<Notification[]> {

        let notificationsFilter = new NotificationsFilter(regions, page, size, start);

        let notifications$ = this._apiService.get(this.baseUrl, this.systemNotificationsPath, notificationsFilter)
            .map(report => { return report.data.map(r => new Notification(r)); }).cache();

        return notifications$;
      }

    getPushNotifications(page = 1,
                         size = 50,
                         start?: string): Observable<PushNotification[]> {

        let pushNotificationsFilter = new PushNotificationsFilter(page, size, start);

        let pushNotifications$ = this._apiService.get(this.baseUrl, this.pushNotificationsPath, pushNotificationsFilter)
            .map(report => { return report.data.map(r => new PushNotification(r)); }).cache();

        return pushNotifications$;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/notifications/shared/services/notifications.service.ts